var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1999 18H1.7999C1.56121 18 1.33229 17.9052 1.16351 17.7364C0.994723 17.5676 0.899902 17.3387 0.899902 17.1V0.9C0.899902 0.661305 0.994723 0.432387 1.16351 0.263604C1.33229 0.0948211 1.56121 0 1.7999 0H16.1999C16.4386 0 16.6675 0.0948211 16.8363 0.263604C17.0051 0.432387 17.0999 0.661305 17.0999 0.9V17.1C17.0999 17.3387 17.0051 17.5676 16.8363 17.7364C16.6675 17.9052 16.4386 18 16.1999 18ZM15.2999 16.2V1.8H2.6999V16.2H15.2999ZM5.3999 4.5H12.5999V6.3H5.3999V4.5ZM5.3999 8.1H12.5999V9.9H5.3999V8.1ZM5.3999 11.7H9.8999V13.5H5.3999V11.7Z",
    fill: "#2D9F75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.f0f1d3b4f5bd075bff1496d4b84f9264.svg";
export { ForwardRef as ReactComponent };